import React, { useState, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Pagination,
  Autoplay,
  FreeMode,
  Navigation,
  Thumbs,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

// import ProductLinkCard from "../ecom_section/ProductLinkCard";
import { Link } from "react-router-dom";
import { useSecureFetch2 } from "../../utils/useSecureFetch2";
import ProductLink from "../ecom_section/ProductLink";

export function CarouselSimple({ section }) {
  return (
    <section className="py-12 bg-gray-100">
      {/* Titre + Sous-titre */}
      <div className="text-center mb-12">
        <h1 className="text-3xl font-bold text-orange-700">{section.title}</h1>
        {section.subtitle && (
          <p className="mt-2 text-gray-600">{section.subtitle}</p>
        )}
      </div>
      <div>
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          loop={true}
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="h-[30vh] partner-carousel"
        >
          {section.subsections.map((item, index) => {
            const imageUrl = item.image
              ? `${process.env.REACT_APP_API_BASE_URL_STORAGE}/${item.image}`
              : item.image_mobile
              ? `${process.env.REACT_APP_API_BASE_URL_STORAGE}/${item.image_mobile}`
              : null;

            return (
              <SwiperSlide key={index}>
                <div className="flex items-center justify-center max-h-[300px]">
                  {imageUrl && (
                    <img
                      src={imageUrl}
                      alt={`slide-${index}`}
                      className="max-h-full max-w-full object-contain"
                    />
                  )}
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
}

export function CarouselProduits({ section }) {
  const { db, loading } = useSecureFetch2("product");

  const produits = useMemo(() => db.data || [], [db]);

  const produitsFiltres = useMemo(() => {
    return produits
      .filter((prod) => {
        const variation = prod.variations?.[0];
        const category = (prod.category || "").toLowerCase();
        return (
          variation &&
          parseFloat(variation.purchase_price || "0") > 0 &&
          category !== "assurance"
        );
      })
      .sort((a, b) => b.product_id - a.product_id);
  }, [produits]);

  return (
    <section className="py-12 bg-gray-100">
      {/* Titre + Sous-titre */}
      <div className="text-center mb-12">
        <h1 className="text-3xl font-bold text-orange-700">{section.title}</h1>
        {section.subtitle && (
          <p className="mt-2 text-gray-600">{section.subtitle}</p>
        )}
      </div>
      <div>
        {/* DESKTOP */}
        <div className="flex items-start gap-10 max-w-6xl mx-auto mt-12">
          <div className="w-full">
            {loading ? (
              <Swiper
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  640: {
                    slidesPerView: 1.2, // léger décalage pour mobile large
                  },
                  768: {
                    slidesPerView: 1.5,
                  },
                  1024: {
                    slidesPerView: 2,
                  },
                }}
                spaceBetween={20}
                className="w-full p-8 animate-pulse"
              >
                {Array.from({ length: 5 }).map((_, i) => (
                  <>
                    <SwiperSlide key={i}>
                      <div className="bg-white rounded-2xl shadow-md p-4 flex flex-col min-h-[375px]">
                        <div className="w-full h-40 bg-gray-200 rounded mb-3"></div>
                        <div className="h-3 w-24 bg-gray-300 rounded mb-1"></div>
                        <div className="h-4 w-40 bg-gray-300 rounded mb-1"></div>
                        <div className="h-4 w-20 bg-gray-300 rounded mb-2"></div>
                        <div className="h-8 w-full bg-gray-300 rounded mt-auto"></div>
                      </div>
                    </SwiperSlide>
                  </>
                ))}
              </Swiper>
            ) : (
              <>
                <Swiper
                  loop
                  spaceBetween={20}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                    },
                    640: {
                      slidesPerView: 1.2, // léger décalage pour mobile large
                    },
                    768: {
                      slidesPerView: 1.5,
                    },
                    1024: {
                      slidesPerView: 2,
                    },
                  }}
                  className="w-full h-full product-carousel p-6 sm:p-8"
                >
                  {produitsFiltres.slice(0, 12).map((prod, i) => (
                    <SwiperSlide key={i}>
                      <div className="bg-white rounded-md shadow-lg p-4 text-center flex flex-col min-h-[375px] hover:-translate-y-1 transition-all duration-300">
                        <ProductLink
                          product={prod}
                          imageHeight="h-40 sm:h-48 md:h-56 lg:h-64"
                        />
                        <div className="flex flex-col md:flex-row justify-between gap-3 mt-auto">
                          <Link
                            to={`/boutique/produit/${prod.product_id}`}
                            state={{ prod }}
                            className="bg-orange-600 hover:bg-orange-700 text-white text-sm px-4 py-2 rounded w-full flex items-center justify-center gap-2"
                          >
                            <i className="fas fa-shopping-cart"></i> Voir
                          </Link>
                          <Link
                            to="/prendre-rdv"
                            className="bg-transparent text-[#74BB43] transition-all duration-300 border border-[#74BB43] hover:bg-green-700 hover:text-white text-sm px-4 py-2 rounded w-full flex items-center justify-center gap-2"
                          >
                            SHOWROOM
                          </Link>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>

                <div className="ms-3">
                  <Link
                    to="/boutique/catalogue"
                    className="inline-block hover:translate-x-1 transition-all duration-300"
                  >
                    <i className="fa-solid fa-caret-right text-[#74BB43]"></i>{" "}
                    Plus de modèles
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export const CarouselWithCaptions = ({ section }) => {
  return (
    <section className="py-12 bg-gray-100">
      {/* Titre + Sous-titre */}
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-gray-900">{section.title}</h2>
        {section.subtitle && (
          <p className="mt-2 text-gray-600">{section.subtitle}</p>
        )}
      </div>
      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        loop={true}
        spaceBetween={20}
        slidesPerView={1}
        breakpoints={{
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {section.subsections.map((item, index) => (
          <SwiperSlide key={index} className="relative">
            <img
              src={
                `${process.env.REACT_APP_API_BASE_URL_STORAGE}/${item.image}` ||
                `${process.env.REACT_APP_API_BASE_URL_STORAGE}/${item.image_mobile}`
              }
              alt={item.title || `slide-${index}`}
              className="w-full h-96 object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col justify-end p-6 text-white">
              {item.title && (
                <h3 className="text-xl font-bold">{item.title}</h3>
              )}
              {item.content && <p className="text-sm mt-1">{item.content}</p>}
              {item.button_text && item.button_link && (
                <a
                  href={item.button_link}
                  className="mt-2 inline-block bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded"
                >
                  {item.button_text}
                </a>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export function CarouselYTB({ section }) {
  const extractYoutubeUrl = (html) => {
    const regex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/;
    const match = html?.match(regex);
    return match ? `https://www.youtube.com/watch?v=${match[1]}` : null;
  };

  const getYoutubeThumbnail = (url) => {
    const match = url.match(/(?:v=|youtu\.be\/)([\w-]+)/);
    return match
      ? `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`
      : null;
  };

  return (
    <div className="w-full py-12 px-4 md:px-8 lg:px-16">
      <div className="max-w-screen-xl mx-auto">
        {section.title && (
          <h2 className="text-3xl md:text-4xl font-bold text-orange-400 mb-8 text-center">
            {section.title}
          </h2>
        )}

        <Swiper
          modules={[Pagination, Autoplay]}
          speed={600}
          loop={true}
          spaceBetween={30}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          grabCursor={true}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="swiper min-h-[320px] partner-carousel"
        >
          {section.subsections.map((sub) => {
            const youtubeUrl = extractYoutubeUrl(sub.content);
            const thumbnail = youtubeUrl
              ? getYoutubeThumbnail(youtubeUrl)
              : null;

            return (
              <SwiperSlide
                key={sub.id}
                className="hover:-translate-y-1 transition-all duration-300"
              >
                <div className="bg-white rounded-xl shadow-md flex flex-col h-[280px] overflow-hidden relative">
                  <div className="h-full w-full overflow-hidden">
                    {thumbnail ? (
                      <a
                        href={youtubeUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={thumbnail}
                          alt={sub.title}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                          <div className="w-20 h-20 bg-white bg-opacity-80 rounded-full flex items-center justify-center shadow-md">
                            <i className="fas fa-play text-orange-600 text-xl ml-1"></i>
                          </div>
                        </div>
                      </a>
                    ) : sub.image ? (
                      <div
                        className={`w-full h-full bg-gray-100 flex items-center justify-center text-orange-400 mb-3`}
                      >
                        <i className="fas fa-image fa-lg"></i>
                      </div>
                    ) : (
                      <div className="w-full h-full bg-orange-100 flex items-center justify-center text-orange-400">
                        <i className="fas fa-image fa-lg"></i>
                      </div>
                    )}
                  </div>
                  <div className="p-3 text-center">
                    <h5 className="text-md font-semibold text-orange-500">
                      {sub.title}
                    </h5>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div className="swiper-pagination mt-6"></div>
      </div>
    </div>
  );
}

const CarouselDetails = ({ section }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const imageBaseUrl = process.env.REACT_APP_API_BASE_URL_STORAGE;

  if (!section?.subsections?.length) return null;

  return (
    <section className="px-6 md:px-12 py-20 bg-black text-white">
      {/* Titre principal */}
      <div className="mb-12 text-center">
        <h2 className="font-bold">{section.title}</h2>
        {section.subtitle && <h3 className="mt-2">{section.subtitle}</h3>}
      </div>

      {/* Main Swiper (Images) */}
      <Swiper
        style={{
          "--swiper-navigation-color": "#74BB43",
          "--swiper-pagination-color": "#74BB43",
        }}
        loop={true}
        spaceBetween={10}
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper2 mb-6 rounded overflow-hidden"
      >
        {section.subsections.map((item) => (
          <SwiperSlide key={item.id}>
            <img
              src={`${imageBaseUrl}/${item.image}`}
              alt={item.title || "Image"}
              className="h-[400px] object-contain mx-auto"
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Thumbnail Swiper */}
      <div className="max-h-30 overflow-hidden">
        <Swiper
          onSwiper={setThumbsSwiper}
          loop={true}
          spaceBetween={10}
          slidesPerView={4}
          freeMode={true}
          watchSlidesProgress={true}
          modules={[FreeMode, Navigation, Thumbs]}
          className="mySwiper"
        >
          {section.subsections.map((item) => (
            <SwiperSlide key={item.id}>
              <img
                src={`${imageBaseUrl}/${item.image}`}
                alt={item.title || "Thumbnail"}
                className="cursor-pointer w-full h-16 md:h-20 object-contain rounded"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default CarouselDetails;
